module.exports = __webpack_public_path__ + "static/media/kebab.f599abb7.jpg";